/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { ProfilePageWrapper, ContentWrapper, PageHeading } from '../Profile/Profile.styles';
import { SubscriptionWrapper, SingleHotlist, ActionsWrapepr } from './Subscriptions.styles';
import { Sidebar } from '../../components/Sidebar';
import { Box, FormGroup, IconButton, Typography, FormControlLabel, Button, Dialog } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { StyledBreadcrumbs } from '../Configuration/Clients/Clients.styled';
import { ReactComponent as ChevronRight } from '../../assets/icons/base/chevron-right.svg';
import { ReactComponent as HomeIcon } from '../../assets/icons/base/home.svg';
import api from '../../api/base';
import { userSubscriptions } from '../../api/paths';
import useError from '../../hooks/useError';

import { Checkbox } from '../../components/common/Checkbox';

export interface SubscriptionsProps {
  id: string;
  alert_sms: boolean;
  alert_email: boolean;
}

export interface Subscription {
  id: string;
  name: string;
  subscription: SubscriptionsProps | false;
}

export interface ChangeSubProps {
  hotlist: string;
  alert_sms?: boolean;
  alert_email?: boolean;
}


const Subscriptions = () => {
  const [handleError] = useError();
  const [currentHotlists, setCurrentHotlists] = useState<Subscription[]>([]);
  const [loader, setLoader] = useState(false);
  const [unsub, setUnsub] = useState('');
  const [currentChangedSettings, setCurrentChangedSettings] = useState<ChangeSubProps>({
    hotlist: '',
    alert_email: true,
    alert_sms: false,
  });
  const [selectedHotlist, setSelectedHotlist] = useState<Subscription | null>(null);

  const getCurrentHotlists = async () => {
    try {
      const response = await api.get(userSubscriptions);
      setCurrentHotlists(response.data);
    } catch (error) {
      handleError(error);
    }
  };


  const changeHostlistSettings = async () => {
    setLoader(true);
    try {
      const response = await api.post(userSubscriptions, currentChangedSettings);
      setSelectedHotlist(null);
      setCurrentChangedSettings({ hotlist: '', alert_email: true, alert_sms: false });
      await getCurrentHotlists();
      setLoader(false);
    } catch (error) {
      handleError(error);
      setLoader(false);
    }
  };

  const changeSubscription = async ({ hotlist, alert_email, alert_sms }: ChangeSubProps) => {
    try {
      const response = await api.patch(`${userSubscriptions}${hotlist}`, {
        alert_email,
        alert_sms,
      });
      await getCurrentHotlists();
    } catch (error) {
      handleError(error);
    }
  };

  const unsubscribeHandler = async (id: string) => {
    setUnsub(id);
    try {
      const response = await api.delete(`${userSubscriptions}${id}`);
      await getCurrentHotlists();
      setUnsub('');
    } catch (error) {
      handleError(error);
      setUnsub('');
    }
  };

  useEffect(() => {
    getCurrentHotlists();
  }, []);

  const handleChange = (data: ChangeSubProps) => {
    setCurrentChangedSettings({
      ...currentChangedSettings,
      ...data,
    });
  };

  useEffect(() => {
    if (selectedHotlist) setCurrentChangedSettings({ ...currentChangedSettings, hotlist: selectedHotlist.id });
    else setCurrentChangedSettings({ ...currentChangedSettings, hotlist: '' });
  }, [selectedHotlist]);

  return (
    <Sidebar>
      <Dialog
        open={selectedHotlist !== null}
        onClose={() => setSelectedHotlist(null)}
        maxWidth={'xs'}
        fullWidth
      >
        {selectedHotlist !== null && (
          <Box
            py={6}
            px={4}
            bgcolor={'base.background'}
            width={'100%'}
            sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}
          >
            <Typography textAlign={'left'} mb={2} variant='body1'>
              You are subscribing to {selectedHotlist.name} hotlist
            </Typography>
            <FormGroup sx={{ mb: 4 }}>
              <FormControlLabel
                control={<Checkbox
                  onChange={(e) => handleChange({ hotlist: selectedHotlist.id, alert_sms: e.target.checked })}
                  name={'alert_sms'}
                  checked={currentChangedSettings?.alert_sms}
                />}
                label={'SMS Alert'}
                labelPlacement={'end'}
              />
              <FormControlLabel
                control={<Checkbox
                  onChange={(e) => handleChange({ hotlist: selectedHotlist.id, alert_email: e.target.checked })}
                  name={'alert_email'}
                  checked={currentChangedSettings?.alert_email}
                />}
                label={'Email Alert'}
                labelPlacement={'end'}
              />
            </FormGroup>
            <LoadingButton loading={loader} onClick={() => changeHostlistSettings()} variant={'contained'}>Confirm subscription</LoadingButton>
          </Box>
        )}
      </Dialog>
      <Box p={6}>
        <Typography fontWeight={'bold'} variant={'dxs'}>
          Subscriptions
        </Typography>
      </Box>
      <ProfilePageWrapper>
        <ContentWrapper>
          <PageHeading>
            <StyledBreadcrumbs separator={<ChevronRight />}>
              <IconButton onClick={() => { }}>
                <HomeIcon />
              </IconButton>
              <Typography mt="18px" variant="tsm" fontWeight="500">
                Subscriptions
              </Typography>
            </StyledBreadcrumbs>
            <Typography variant="dxs" color="base.bodyText" fontWeight="600">
              Subscriptions
            </Typography>
          </PageHeading>
          <SubscriptionWrapper>
            {currentHotlists?.map((item: Subscription, i: number) => {
              return (
                <SingleHotlist key={item.name}>
                  <Typography variant={'body1'}>
                    {item.name}
                  </Typography>
                  {item.subscription !== false && (
                    <FormGroup row>
                      <FormControlLabel
                        control={<Checkbox
                          onChange={(e) => changeSubscription({ hotlist: item.id, alert_sms: e.target.checked })}
                          name={'alert_sms'}
                          defaultChecked={item.subscription.alert_sms}
                        />}
                        label={'SMS Alert'}
                        labelPlacement={'end'}
                      />
                      <FormControlLabel
                        control={<Checkbox
                          onChange={(e) => changeSubscription({ hotlist: item.id, alert_email: e.target.checked })}
                          name={'alert_email'}
                          defaultChecked={item.subscription.alert_email}
                        />}
                        label={'Email Alert'}
                        labelPlacement={'end'}
                      />
                    </FormGroup>
                  )}
                  <ActionsWrapepr>
                    {item.subscription !== false
                      ? (
                        <LoadingButton loading={unsub === item.id} onClick={() => unsubscribeHandler(item.id)} variant={'contained'}>
                          Unsubscribe
                        </LoadingButton>
                      )
                      : (
                        <Button onClick={() => setSelectedHotlist(item)} variant={'contained'}>
                          Subscribe
                        </Button>
                      )}
                  </ActionsWrapepr>
                </SingleHotlist>
              );
            })}
          </SubscriptionWrapper>
        </ContentWrapper>
      </ProfilePageWrapper>
    </Sidebar>
  );
};

export default Subscriptions;
